import { useState } from 'react';
import './index.css';
import { useStore } from './hooks/useStore';
import { Sidebar } from './components/Sidebar';
import { HomePage } from './pages/HomePage';
import { PartiesPage } from './pages/PartiesPage';
import { PartyDetailPage } from './pages/PartyDetailPage';
import { CashbookPage } from './pages/CashbookPage';
import { ReportsPage } from './pages/ReportsPage';
import { SettingsPage } from './pages/SettingsPage';

export default function App() {
  const store = useStore();
  const [view, setView]             = useState('home');
  const [selectedParty, setSelected] = useState(null);

  if (store.loading) return (
    <div className="loading">
      <div className="loading-spin" />
      Loading Cashbook…
    </div>
  );
  if (store.error) return (
    <div className="loading" style={{ flexDirection: 'column', gap: 12 }}>
      <div style={{ fontSize: 36 }}>⚠️</div>
      <div style={{ color: 'var(--red-dark)', fontWeight: 600 }}>Cannot connect to server</div>
      <div style={{ color: 'var(--text-faint)', fontSize: 13 }}>Make sure the backend is running on port 3001</div>
      <pre style={{ background: '#fff3', padding: '8px 14px', borderRadius: 8, fontSize: 12 }}>
        cd backend{'\n'}python3 server.py
      </pre>
    </div>
  );

  const owedCount = store.parties.filter(p => p.balance > 0).length;

  const handlePartyClick = (party) => {
    setSelected(party);
    setView('party-detail');
  };

  const handleNav = (v) => {
    setView(v);
    setSelected(null);
  };

  const topbarTitles = {
    home: 'Home',
    parties: 'Parties',
    cashbook: 'Cashbook',
    reports: 'Reports',
    settings: 'Settings',
    'party-detail': selectedParty?.name || '',
  };

  return (
    <div className="app">
      <Sidebar
        business={store.business}
        view={view}
        onNav={handleNav}
        owedCount={owedCount}
      />

      <div className="main">
        {/* Top bar */}
        <div className="topbar">
          <div className="topbar-left">
            {view === 'party-detail' && (
              <button className="btn btn-sm" onClick={() => handleNav('parties')}>← Back</button>
            )}
            <div>
              <div className="topbar-title">{topbarTitles[view] || ''}</div>
              {view === 'home' && store.summary && (
                <div className="topbar-sub">
                  Net: {store.summary.you_will_get >= store.summary.you_will_give
                    ? `₹${(store.summary.you_will_get - store.summary.you_will_give).toLocaleString('en-IN')} will get`
                    : `₹${(store.summary.you_will_give - store.summary.you_will_get).toLocaleString('en-IN')} will give`}
                </div>
              )}
            </div>
          </div>
          <div className="topbar-actions">
            {view === 'parties' && (
              <button className="btn btn-blue btn-sm" onClick={() => setView('parties')}>
                ➕ Add Party
              </button>
            )}
          </div>
        </div>

        {/* Pages */}
        {view === 'home' && (
          <HomePage
            summary={store.summary}
            parties={store.parties}
            onNav={handleNav}
            onPartyClick={handlePartyClick}
          />
        )}

        {view === 'parties' && (
          <PartiesPage
            parties={store.parties}
            onAdd={store.addParty}
            onPartyClick={handlePartyClick}
            onDelete={store.deleteParty}
          />
        )}

        {view === 'party-detail' && selectedParty && (
          <PartyDetailPage
            party={selectedParty}
            onBack={() => handleNav('parties')}
            onUpdate={store.updateParty}
            onDelete={store.deleteParty}
            onAddTxn={store.addTransaction}
            onDelTxn={store.delTransaction}
          />
        )}

        {view === 'cashbook' && (
          <CashbookPage
            parties={store.parties}
            onPartyClick={handlePartyClick}
          />
        )}

        {view === 'reports' && (
          <ReportsPage parties={store.parties} />
        )}

        {view === 'settings' && (
          <SettingsPage
            business={store.business}
            onUpdate={store.updateBusiness}
          />
        )}
      </div>
    </div>
  );
}
